"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPINNER_TYPES = exports.SPINNER_SIZES = void 0;
const MASK_COLORS = ['gray', 'white'];
const SPINNER_SIZES = exports.SPINNER_SIZES = ['lg', 'md', 'sm'];
const SPINNER_TYPES = exports.SPINNER_TYPES = ['block', 'fullScreen', 'fullPage', 'inline'];